var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.69356 4.72287L15.3607 17.0894M2.69356 4.72287C3.16486 4.18482 3.86878 3.84324 4.65524 3.84324H8.93741M2.69356 4.72287C2.31451 5.15562 2.08594 5.71546 2.08594 6.3269V15.4337C2.08594 16.8053 3.23625 17.9173 4.65524 17.9173H14.076C15.495 17.9173 16.6453 16.8053 16.6453 15.4337V11.7082M8.93741 11.7082L3.37059 17.0894M15.0074 4.8988V4.84588M17.9193 4.83761C17.9193 6.67336 15.0074 9.12102 15.0074 9.12102C15.0074 9.12102 12.0955 6.67336 12.0955 4.83761C12.0955 3.31682 13.3992 2.08398 15.0074 2.08398C16.6156 2.08398 17.9193 3.31682 17.9193 4.83761Z",
    stroke: "#102039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapView);
export default __webpack_public_path__ + "static/media/mapView.2d8d5760452d673410868a0b13b3c33f.svg";
export { ForwardRef as ReactComponent };